import type { components } from "../../api/generated/schema";
import type { ResinFamilyGroup } from "../nomenclature/database/resinGroups";
import type { ApprovedCodeView } from "../nomenclature/types";

type Schemas = components["schemas"];

export type RegistrySlot = "Base" | "Additive" | "Color";
export type CodeFieldKey = "designationId" | "baseCodeId" | "additiveCodeId" | "colorCodeId";
export type CodePicks = Record<CodeFieldKey, string>;

export interface ResinContext {
  resinFamilyCode: string;
  resinCodes: ResinFamilyGroup;
  registryCodes: Record<RegistrySlot, ApprovedCodeView[]>;
}

export type RefCode = Schemas["RefCode"];
export type LogEntry = Schemas["CockpitLogEntry"];
export type LogKind = NonNullable<LogEntry["kind"]>;
export type RosterSupplier = Schemas["CockpitRosterSupplier"];

export type PricePoint = Schemas["CockpitPricePoint"];
export type PricePointCreate = Schemas["CockpitPricePointCreate"];
export type PriceHistory = Schemas["CockpitPriceHistory"];
export type PriceHistoryCall = Schemas["CockpitPriceHistoryCall"];
export type PriceHistoryForecast = Schemas["CockpitPriceHistoryForecast"];
export type Nomination = Schemas["CockpitNomination"];
export type NominationCreate = Schemas["CockpitNominationCreate"];
export type Headline = Schemas["MarketHeadline"];
export type HeadlineCreate = Schemas["MarketHeadlineCreate"];
export type PublisherView = Schemas["PublisherForecast"];
export type PublisherViewCreate = Schemas["PublisherForecastCreate"];
export type Note = Schemas["ConsultantNote"];
export type NoteCreate = Schemas["ConsultantNoteCreate"];

export type Call = Schemas["MakeTheCall"];
export type CallDetail = Schemas["MakeTheCallDetail"];
export type CallCreate = Schemas["MakeTheCallCreate"];
export type CallGuidance = Schemas["MakeTheCallGuidance"];
export type LandedPriceUse = CallCreate["landedPriceUseCode"];

export type MarketView = Schemas["MarketView"];
export type MarketViewCreate = Schemas["MarketViewCreate"];
export type MarketBriefData = Schemas["MarketBrief"];
export type TeamMarketView = Schemas["TeamMarketView"];
export type MarketTeamViewData = Schemas["MarketTeamView"];

export const CODE_SETS = [
  "PriceType",
  "CockpitPriceBasis",
  "CockpitPriceSource",
  "GradeConfirmation",
  "AnnouncementStatus",
  "ForecastMeasure",
  "HeadlineRegion",
] as const;
export type CodeSetName = (typeof CODE_SETS)[number];

export interface Lookups { 
  codes: Record<CodeSetName, RefCode[]>;
  roster: RosterSupplier[];
}

export type TabKey = "price" | "nomination" | "headline" | "publisher" | "note" | "roster";

export type Values = Record<string, string>;

export interface LogRequest {
  kind: LogKind;
  recordId: number | null;
  recordMonth: string;
  presetValues?: Values;
}

export interface NumberedLogRequest extends LogRequest {
  requestNumber: number;
}